import { render, staticRenderFns } from "./LeadChangeConfirmation.vue?vue&type=template&id=737444b4&scoped=true"
import script from "./LeadChangeConfirmation.vue?vue&type=script&lang=js"
export * from "./LeadChangeConfirmation.vue?vue&type=script&lang=js"
import style0 from "./LeadChangeConfirmation.vue?vue&type=style&index=0&id=737444b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737444b4",
  null
  
)

export default component.exports